import React, { useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
// import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
// import Select from '@material-ui/core/Select';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputBase from '@material-ui/core/InputBase';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useHistory } from 'react-router-dom';
import { fetchAllProjects, createNewFile, createNewProject } from '../../actions/projectActions';
import { CREATE_FILE_RESET } from '../../constants/projectConstants';
import { useDispatch, useSelector } from 'react-redux';
import { CircularProgress } from '@material-ui/core';
import {
    GENERATE_LINKEDINAD_RESET,
    GENERATE_TAGLINE_RESET,
    GENERATE_AMAZONDESC_RESET,
    GENERATE_GOOGLEAD_RESET,
    GENERATE_BLOGINTRO_RESET,
    GENERATE_BLOGQUOTE_RESET,
    GENERATE_BLOGIDEAS_RESET,
    GENERATE_DISPLAYADS_RESET,
    GENERATE_FAQ_RESET,
    GENERATE_PAINAGITATE_RESET,
    GENERATE_FACEBOOKAD_RESET,
} from '../../constants/generateConstants';

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 4,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderRadius: 4,
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(1),
    },
}));

function SaveFile({ saveFileDialog, setSaveFileDialog, type, generateArray, isBookmarked, bookmarkArray }) {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const [fileName, setFileName] = React.useState("");
    const [folderId, setFolderId] = React.useState('');
    const [errorMessage, setErrorMessage] = React.useState('');

    const currentWorkSpace = useSelector(state => state.currentWorkSpace);
    const { currentWorkspaceDetails } = currentWorkSpace;

    const allProjects = useSelector(state => state.allProjects);
    const { projectDetails, success } = allProjects;

    const createProject = useSelector(state => state.createProject);
    const { loading: loadingNewProject, error: errorNewProject, projectInfo } = createProject;

    const createFile = useSelector(state => state.createFile);
    const { loading, error, fileInfo } = createFile;

    const linkedinAdGenerate = useSelector(state => state.linkedinAdGenerate);
    const { companyName: linkedInCompanyName, companyDesc: linkedInCompanyDesc } = linkedinAdGenerate;

    const taglineGenerate = useSelector(state => state.taglineGenerate);
    const { companyName: taglineCompanyName, companyDesc: taglineCompanyDesc } = taglineGenerate;

    const googleAdGenerate = useSelector(state => state.googleAdGenerate);
    const { adDesc } = googleAdGenerate;

    const blogIdeasGenerate = useSelector(state => state.blogIdeasGenerate);
    const {blogDesc: blogIdeasBlogDesc} = blogIdeasGenerate;

    const blogQuoteGenerate = useSelector(state => state.blogQuoteGenerate);
    const {blogTitle: blogQuoteBlogTitle, blogDesc: blogQuoteBlogDesc} =blogQuoteGenerate;

    const blogIntroGenerate = useSelector(state => state.blogIntroGenerate);
    const {blogTitle: blogIntroBlogTitle, blogDesc: blogIntroBlogDesc} = blogIntroGenerate;

    const displayAdsGenerate = useSelector(state => state.displayAdsGenerate);
    const {topic: displayAdsTopic} = displayAdsGenerate;
    


    const FaqGenerate = useSelector(state => state.FaqGenerate);
    const {topic: FaqTopic} = FaqGenerate;
    

    const painAgitateGenerate = useSelector(state => state.painAgitateGenerate);
    const {topic: painAgitateTopic} = painAgitateGenerate;

    const facebookAdGenerate = useSelector(state => state.facebookAdGenerate);
    const { facebookadDesc } = facebookAdGenerate;


    const handleChange = (event) => {
        setFolderId(event.target.value);
    };

    const handleClose = () => {
        setSaveFileDialog(false);
        if (type === 'LINKEDIN_ADD') {
            dispatch({ type: GENERATE_LINKEDINAD_RESET });
        }

        if (type === 'TAGLINE') {
            dispatch({ type: GENERATE_TAGLINE_RESET });
        }

        if (type === 'amazonDesc') {
            dispatch({ type: GENERATE_AMAZONDESC_RESET });
        }

        if (type === 'GOOGLE_ADD') {
            dispatch({ type: GENERATE_GOOGLEAD_RESET });
        }

        if (type === 'BLOG_IDEAS') {
            dispatch({ type: GENERATE_BLOGIDEAS_RESET });
        }

        if (type === 'BLOG_QUOTE') {
            dispatch({ type: GENERATE_BLOGQUOTE_RESET });
        }

        if (type === 'BLOG_INTRO') {
            dispatch({ type: GENERATE_BLOGINTRO_RESET });
        }

        if (type === 'DISPLAY_ADS') {
            dispatch({ type: GENERATE_DISPLAYADS_RESET });
        }

        if (type === 'DISPLAY_ADS') {
            dispatch({ type: GENERATE_FAQ_RESET });
        }

        if (type === 'PAIN_AGITATE_SOLUTION') {
            dispatch({ type: GENERATE_PAINAGITATE_RESET });
        }

        if (type === 'FACEBOOK_ADD') {
            dispatch({ type: GENERATE_FACEBOOKAD_RESET });
        }


        history.push("/home");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (currentWorkspaceDetails && currentWorkspaceDetails._id) {
            dispatch(createNewProject({
                name: "Default Folder",
                workspaceId: currentWorkspaceDetails._id,
            }))
        }
    }

    useEffect(() => {
        if (fileInfo) {
            dispatch({ type: CREATE_FILE_RESET })
            handleClose();
        }
    }, [fileInfo, history])

    useEffect(() => {
        if (currentWorkspaceDetails) {
            dispatch(fetchAllProjects(currentWorkspaceDetails._id));
        }
    }, [currentWorkspaceDetails, dispatch, projectInfo]);


    const handleSave = () => {
        // let fileType = type.toUpperCase()
        let resultData = [];
        let companyInfo = {
            companyName: 'Company Name',
            description: "Description",
        }

        if (type === 'LINKEDIN_ADD') {
            companyInfo.companyName = linkedInCompanyName;
            companyInfo.description = linkedInCompanyDesc;
        }
        if (type === 'TAGLINE') {
            companyInfo.companyName = taglineCompanyName;
            companyInfo.description = taglineCompanyDesc
        }

        if (type === 'GOOGLE_ADD') {
            companyInfo.description = adDesc
        }

        if (type === 'BLOG_IDEAS') {
            companyInfo.description = blogIdeasBlogDesc;
            // companyInfo.companyName = blogName;          
        }

        if (type === 'BLOG_QUOTE') {
            companyInfo.companyName = blogQuoteBlogTitle;
            companyInfo.description = blogQuoteBlogDesc;
        }

        if (type === 'BLOG_INTRO') {
            companyInfo.companyName = blogIntroBlogTitle;
            companyInfo.description = blogIntroBlogDesc;
        }

        if (type === 'DISPLAY_ADS') {
            companyInfo.description = displayAdsTopic;
            
        }

        
        if (type === 'FAQ') {
            companyInfo.description = FaqTopic;
            
        }

        if (type === 'PAIN_AGITATE_SOLUTIONS') {
            debugger
            companyInfo.description = painAgitateTopic;
            
        }

        if (type === 'FACEBOOK_ADD') {
            companyInfo.description = facebookadDesc;
        }


        let i = 0;
        let isBookmarkWhole = isBookmarked
        for (let val of generateArray) {
            let resultVal = {
                content: val.text.substr(8),
                bookmark: bookmarkArray[i]
            }
            if (bookmarkArray[i] === true) {
                isBookmarkWhole = true;
            }
            i = i + 1;
            resultData.push(resultVal);
        }
        if (generateArray.length > 0 && folderId) {
            // let firstIndexVal = { content: resultData[0].content, bookmark: isBookmarked };
            // resultData[0] = firstIndexVal;
            let finalData = {
                name: fileName,
                type: type,
                bookmark: isBookmarkWhole,
                companyName: companyInfo.companyName,
                description: companyInfo.description,
                results: resultData,
                folderId: folderId
            }
            console.log(finalData);
            dispatch(createNewFile(finalData));
        } else if (generateArray.length !== 0 && !folderId) {
            setErrorMessage("No folder selected !")
        } else {
            history.push('/home');
        }

    }

    return (
        <div>
            <Dialog open={saveFileDialog}
                PaperProps={{ style: { minWidth: "220px", padding: "1rem" } }}
                maxWidth="xs" onClose={handleClose} aria-labelledby="form-dialog-title" style={{ justifyContent: "center", alignItems: "center" }}>
                <DialogTitle id="form-dialog-title">Save</DialogTitle>
                <DialogContent>
                    {(error || errorNewProject || errorMessage) && <h4>{error || errorNewProject || errorMessage}</h4>}
                    <DialogContentText>
                        Add a new file name and select the folder to save the file.
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        value={fileName}
                        onChange={e => setFileName(e.target.value)}
                        label="File Name"
                        type="text"
                    />
                    <br />
                    {(success && projectDetails && projectDetails.length > 0) ? (
                        < FormControl className={classes.margin}>
                            <InputLabel htmlFor="demo-customized-select-native">Select Folder</InputLabel>
                            <NativeSelect
                                style={{ width: "150px" }}
                                placeholder="Select Folder"
                                id="demo-customized-select-native"
                                value={folderId}
                                onChange={handleChange}
                                input={<BootstrapInput />}
                            >
                                <option aria-label="None" value="" />
                                {projectDetails?.map((item) => (
                                    <option key={item._id} value={item._id}>{item.name}</option>
                                ))}
                            </NativeSelect>
                        </FormControl>
                    ) : loadingNewProject ? <CircularProgress /> : (
                        <Button onClick={handleSubmit} color="primary">
                            Create a new project
                        </Button>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Exit without saving
                    </Button>
                    {loading ? <CircularProgress /> : (
                        <Button onClick={handleSave} color="primary">
                            Save and Exit
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        </div >
    );
}

export default SaveFile;